import { Transaction } from "@/api/transactions";
import {
	formatTransactionAmount,
	getFormattedTransactionDate,
	getTransactionIcon,
	getTransactionStatusLabel,
	getTransactionStatusClassName,
} from "@/pages/Home/activity/_components/utils";

type ActivityProps = {
	transaction: Transaction;
};

const ActivityRowItem = ({ transaction }: ActivityProps) => {
	const transactionStatus = getTransactionStatusLabel(
		transaction.transaction_type_name,
		transaction.transaction_status,
	);

	return (
		<div className="text-textDark">
			<div className="flex items-center justify-between">
				<div className="flex items-center space-x-3">
					<div className="p-3 inline-flex items-center justify-center rounded-full bg-primary-50 ">
						{getTransactionIcon(transaction.transaction_type_name)}
					</div>
					<div className="text-sm font-bold text-textDark">
						<div className="flex items-center gap-2">
							<p>{transaction.transaction_type_name}</p>
							<span className="text-sm font-medium text-textLight opacity-80">
								(ID: {transaction.transaction_id})
							</span>
						</div>
						<p className="opacity-40 font-medium">
							{getFormattedTransactionDate(transaction.created_datetime)}
						</p>
					</div>
				</div>
				<div className="text-right text-sm text-textDark">
					<div className="font-bold text-right">
						{formatTransactionAmount(
							transaction.transaction_type_name,
							transaction.amount,
						)}
					</div>
					<div
						className={getTransactionStatusClassName(
							transaction.transaction_status,
						)}
					>
						{transactionStatus}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ActivityRowItem;
